export class ArticleinfoModel {
  ArticleInfoAutoLoad: boolean;
  lSubjectList: any;
  lJournalList: any;
  lStatusList: any;
  lAuthorList: any;
  lFirstReleaseList: any;
  lWorkflowList: any;
  lHoldReleaseList: any;
  lLogList: any;
  lFileList: string[] = [];

  CIDNumberApi: string = "";
  articleListApi: string = "";
  articleInfoByNoApi: string = "";
  articleByIdApi: string = "";
  updateNotesApi: string = "";
  updateInComplete: string = "";
  updateHoldReleaseApi: string = "";
  updateArticleApi: string = "";
  articleTypeApi: string = "";
  firstReleaseRequestApi: string = "";
  uploadFirstReleaseApi: string = "";
  statusListApi: string = "";
  journalListApi: string = "";
  journalNotesApi: string = "";
  egApprove: string = "";
  eptApprove: string = "";
  downloadFpApi: string = "";
  downloadWfApi: string = "";
  downloadGpApi: string = "";
  downloadParserErrorApi: string = "";
  downloadIngestionPackage: string = "";
  downloadECUApi: string = "";
  downloadHrApi: string = "";
  downloadNotesApi: string = "";
  uploadCorrectionApi: string = "";
  uploadQcCorrectionApi: string = "";
  uploadExpressCorrection: string = "";
  oneMoreReviewApi: string = "";
  approveApi: string = "";
  approveQcApi: string = "";
  updateAllocateApi: string = "";
  atyponUploadApi: string = "";
  atyponLogApi: string = "";
  uploadAtypeonCorrectionApi: string = "";
  checkVolumeIssueApi: string = "";
  checkArticlePublishApi: string = "";
  downloadReferenceNote: string = "";
  populateReferenceNote: string = "";
  referenceNoteUpload: string = "";
  revisedFileApproveApi: string = "";
  proofingApproveApi: string = "";
  oneMoreReviewSignalApi: string = "";
  getQueryTypeList: string = "";
  ProofingConfigPreview: string = "";
  proofingEPTApproveApi: string = "";
  uploadProofingEPTCorrectionApi: string = "";
  proofingEmailTemplateApi: string = "";
  ProjectPlanDateModify: any;

  //Variables
  articleNo: string;
  articleTitle: string;
  articleSubTitle: string;
  articleType: string;
  authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  isHold: boolean;
  holdType: string;

  showModal: boolean;
  showInfoModal: boolean;
  showNotesModal: boolean;
  showFileUpload: boolean;
  showHoldModal: boolean;
  showRelease: boolean;
  showHoldHistoryModal: boolean;
  showCorrectionModal: boolean;
  showReviewModal: boolean;
  showCorr: boolean;
}
